import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_5ced1511 from 'nuxt_plugin_plugin_5ced1511' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_googletagmanager_0c7f9453 from 'nuxt_plugin_googletagmanager_0c7f9453' // Source: ./google-tag-manager.js (mode: 'client')
import nuxt_plugin_nuxtplugine8481f6c_0cb405b0 from 'nuxt_plugin_nuxtplugine8481f6c_0cb405b0' // Source: ./nuxt.plugin.e8481f6c.js (mode: 'server')
import nuxt_plugin_vuescrollto_b3f88cac from 'nuxt_plugin_vuescrollto_b3f88cac' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_aebb1db2 from 'nuxt_plugin_cookieuniversalnuxt_aebb1db2' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_7537cc9c from 'nuxt_plugin_pluginutils_7537cc9c' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginseo_6f0b9220 from 'nuxt_plugin_pluginseo_6f0b9220' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_8710ba32 from 'nuxt_plugin_pluginrouting_8710ba32' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_025b89e8 from 'nuxt_plugin_pluginmain_025b89e8' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_distplugin732b2535_118af8ec from 'nuxt_plugin_distplugin732b2535_118af8ec' // Source: ./dist.plugin.732b2535.mjs (mode: 'all')
import nuxt_plugin_image_5da8ac7a from 'nuxt_plugin_image_5da8ac7a' // Source: ./image.js (mode: 'all')
import nuxt_plugin_coreplugin66a885d2_6c12a8be from 'nuxt_plugin_coreplugin66a885d2_6c12a8be' // Source: ./core.plugin.66a885d2.ts (mode: 'all')
import nuxt_plugin_pluginse2etesting6c054c32_12281598 from 'nuxt_plugin_pluginse2etesting6c054c32_12281598' // Source: ./plugins.e2e-testing.6c054c32.js (mode: 'all')
import nuxt_plugin_pluginsssr76d7f8ca_b4c34ba6 from 'nuxt_plugin_pluginsssr76d7f8ca_b4c34ba6' // Source: ./plugins.ssr.76d7f8ca.js (mode: 'all')
import nuxt_plugin_googleanalytics_38995972 from 'nuxt_plugin_googleanalytics_38995972' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_deviceplugin_a7e54fec from 'nuxt_plugin_deviceplugin_a7e54fec' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_metaplugin_fb2f0624 from 'nuxt_plugin_metaplugin_fb2f0624' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_f1dfbb3c from 'nuxt_plugin_iconplugin_f1dfbb3c' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_tokenexpired_ca1e20ca from 'nuxt_plugin_tokenexpired_ca1e20ca' // Source: ../plugins/token-expired (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_fcPlugin_5a846bc6 from 'nuxt_plugin_fcPlugin_5a846bc6' // Source: ../plugins/fcPlugin (mode: 'all')
import nuxt_plugin_dompurify_9e093c4a from 'nuxt_plugin_dompurify_9e093c4a' // Source: ../plugins/dompurify (mode: 'all')
import nuxt_plugin_storeConfigPlugin_234467e0 from 'nuxt_plugin_storeConfigPlugin_234467e0' // Source: ../plugins/storeConfigPlugin (mode: 'all')
import nuxt_plugin_meta_32edff3a from 'nuxt_plugin_meta_32edff3a' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Venu’s Digital Arcade","meta":[{"charset":"utf8"},{"name":"viewport","content":"minimum-scale=1.0, width=device-width, maximum-scale=1, user-scalable=no"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"hid":"description","name":"description","content":"Venu’s Digital Arcade"},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"hid":"rzpay","src":"https:\u002F\u002Fcheckout.razorpay.com\u002Fv1\u002Fcheckout.js","defer":true},{"hid":"tawk.to","src":"https:\u002F\u002Fembed.tawk.to\u002F65fc673da0c6737bd12362df\u002F1hpgv6ibl","defer":true},{"src":"\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id=GTM-57BXFS4J&l=dataLayer","async":true}],"style":[],"noscript":[{"hid":"gtm-noscript","innerHTML":"\u003Ciframe src=\"\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-57BXFS4J&l=dataLayer\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"\u003E\u003C\u002Fiframe\u003E","pbody":true}],"__dangerouslyDisableSanitizersByTagID":{"gtm-noscript":["innerHTML"]}},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_5ced1511 === 'function') {
    await nuxt_plugin_plugin_5ced1511(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googletagmanager_0c7f9453 === 'function') {
    await nuxt_plugin_googletagmanager_0c7f9453(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtplugine8481f6c_0cb405b0 === 'function') {
    await nuxt_plugin_nuxtplugine8481f6c_0cb405b0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_b3f88cac === 'function') {
    await nuxt_plugin_vuescrollto_b3f88cac(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_aebb1db2 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_aebb1db2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_7537cc9c === 'function') {
    await nuxt_plugin_pluginutils_7537cc9c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_6f0b9220 === 'function') {
    await nuxt_plugin_pluginseo_6f0b9220(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_8710ba32 === 'function') {
    await nuxt_plugin_pluginrouting_8710ba32(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_025b89e8 === 'function') {
    await nuxt_plugin_pluginmain_025b89e8(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin732b2535_118af8ec === 'function') {
    await nuxt_plugin_distplugin732b2535_118af8ec(app.context, inject)
  }

  if (typeof nuxt_plugin_image_5da8ac7a === 'function') {
    await nuxt_plugin_image_5da8ac7a(app.context, inject)
  }

  if (typeof nuxt_plugin_coreplugin66a885d2_6c12a8be === 'function') {
    await nuxt_plugin_coreplugin66a885d2_6c12a8be(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting6c054c32_12281598 === 'function') {
    await nuxt_plugin_pluginse2etesting6c054c32_12281598(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsssr76d7f8ca_b4c34ba6 === 'function') {
    await nuxt_plugin_pluginsssr76d7f8ca_b4c34ba6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_38995972 === 'function') {
    await nuxt_plugin_googleanalytics_38995972(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_a7e54fec === 'function') {
    await nuxt_plugin_deviceplugin_a7e54fec(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_fb2f0624 === 'function') {
    await nuxt_plugin_metaplugin_fb2f0624(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_f1dfbb3c === 'function') {
    await nuxt_plugin_iconplugin_f1dfbb3c(app.context, inject)
  }

  if (typeof nuxt_plugin_tokenexpired_ca1e20ca === 'function') {
    await nuxt_plugin_tokenexpired_ca1e20ca(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_fcPlugin_5a846bc6 === 'function') {
    await nuxt_plugin_fcPlugin_5a846bc6(app.context, inject)
  }

  if (typeof nuxt_plugin_dompurify_9e093c4a === 'function') {
    await nuxt_plugin_dompurify_9e093c4a(app.context, inject)
  }

  if (typeof nuxt_plugin_storeConfigPlugin_234467e0 === 'function') {
    await nuxt_plugin_storeConfigPlugin_234467e0(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_32edff3a === 'function') {
    await nuxt_plugin_meta_32edff3a(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
